//coordinates are reference from the bottom edge of the grid (closest to camera)

export let MatrixPositionsEdge = [
    [],
    [ [2,10] ],
    [ [0,8], [4,12] ],
    [ [0,8], [0,12], [4,12] ],
    [ [0,8], [0,12], [4,12], [2, 10] ],
    [ [0,8], [0,10], [2,10], [2,12], [4,12] ], 
    [ [0,8], [0,10], [2,12], [4,12], [0,12], [2,10] ],
    [ [0,10], [0,8], [2,12], [2,10], [2,8], [4,12], [4,10] ],
    [ [0,12], [0,10], [0,8], [2,12], [2,10], [2,8], [4,12], [4,10] ],
    [ [0,10], [0,8], [2,12], [2,10], [2,8], [4,12], [4,10], [0,6], [6,12] ],
    [ [0,12], [0,10], [0,8], [2,12], [2,10], [2,8], [4,12], [4,10], [0,6], [6,12] ]
]

export let MatrixPositionsCenter = [
    [],
    [ [6,6] ],
    [ [4,4], [8,8] ],
    [ [2,2], [6,6], [10,10] ],
    [ [0,0], [4,4], [8,8], [12,12] ],
    [ [2,6], [6,2], [6,6], [6,10], [10,6] ], 
    [ [4,4], [4,8], [8,4], [8,8], [8,12], [12,8] ],
    [ [4,4], [4,8], [8,4], [8,8], [8,12], [12,8], [12,12] ],
    [ [4,4], [4,8], [8,4], [8,8], [8,12], [12,8], [0,4], [4,0] ],
    [ [4,4], [4,8], [8,4], [8,8], [8,12], [12,8], [0,4], [4,0], [12,12] ],
    [ [4,4], [4,8], [8,4], [8,8], [8,12], [12,8], [0,4], [4,0], [12,12], [0,0] ],
    [ [2,4], [4,2], [4,4], [4,6], [6,4], [6,8], [8,6], [8,8], [8,10], [10,8], [6,6] ],
    [ [2,4], [4,2], [4,4], [4,6], [6,4], [6,8], [8,6], [8,8], [8,10], [10,8], [10,10], [2,2] ],
    [ [2,4], [4,2], [4,4], [4,6], [6,4], [6,8], [8,6], [8,8], [8,10], [10,8], [6,6], [2,2], [10, 10] ]
]

export let DappCoordinatesWide = [ //relative to (0,0)
     [1,1], [1,-1], [-1,1], [-1,-1], [0,1], [1,0], [-1,0], [0,-1],
]

export let DappCoordinatesExpanded = [ //relative to center
     [],
     [[1,1]],
     [[1,1], [-1,-1]],
     [[1,1], [-1,0], [0,-1]],
     [[0,1], [1,0], [-1,0], [0,-1]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [2,2]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [-2,-2]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1], [0,2]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1], [0,2], [2,0]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1], [0,2], [2,0], [-2,0]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1], [0,2], [2,0], [-2,0], [-2,-1]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1], [0,2], [2,0], [-2,0], [-2,-1], [-2,-2]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1], [0,2], [2,0], [-2,0], [-2,-1], [-2,-2], [-1,-2]],
     [[0,1], [1,0], [-1,0], [0,-1], [1,1], [-1,-1], [-1,1], [1,-1], [2,2], [1,2], [2,1], [0,2], [2,0], [-2,0], [-2,-1], [-2,-2], [-1,-2], [0,-2]]
]